module.exports = __webpack_public_path__ + "static/img/3.d03fa93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work2/3.png
// module id = 6pnQ
// module chunks = 0